import router from './router'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style

NProgress.configure({ showSpinner: false }) // NProgress Configuration

router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()
  
  // set page title
  document.title = 'Login'

  next()
  NProgress.done()
})

router.afterEach(() => {
  NProgress.done()
})
